<template>
    <v-row no-gutters v-if="showWelcome">
        <v-col cols="12">
            <welcome :show-retry-btn="showRetryBtn" :loading="loadingFinish" @continue="onFinish" @retry="onRetry"/>
        </v-col>
    </v-row>
    <v-row v-else>
        <v-col cols="12" md="7" lg="8" v-if="!isMobile" class="img-col"/>
        <v-col cols="12" md="5" lg="4">
            <loading-spinner v-if="!component" />
            <component v-else :is="component" @finish="onFinishStepper"/>
        </v-col>
    </v-row>
</template>

<script>

import BasicInfoStudent from '@/components/student/BasicInfoStepper'
import BasicInfoCoach from '@/components/coach/BasicInfoStepper'
import BasicInfoCompany from '@/components/company/BasicInfoStepper'
import Welcome from '@/components/entrance/Welcome'

import firebase, {db} from "@/utils/Firebase";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import {mapActions} from "vuex";

export default {
    components: {
        LoadingSpinner,
        BasicInfoStudent,
        BasicInfoCoach,
        BasicInfoCompany,
        Welcome,
    },
    data() {
        return {
            showWelcome: false,
            loadingFinish: false,
            showRetryBtn: false,
        }
    },
    computed: {
        component(vm = this) {
            switch (vm.account?.accountType) {
                case 'student':
                    return 'BasicInfoStudent'
                case 'coach':
                    return 'BasicInfoCoach'
                case 'company':
                    return 'BasicInfoCompany'
                default:
                    return null
            }
        }
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        onFinishStepper() {
            const vm = this
            vm.showWelcome = true
        },
        acceptInvitation: firebase.functions().httpsCallable('httpInvitations-acceptStudentInvitation'),
        async onFinish() {
            const vm = this
            vm.loadingFinish = true
            await vm.bindUserAccount(vm.currentUser)

            if(vm.accountType === 'student') {
                let studentInvitationsRef = await db.collection('studentInvitations')
                    .where('studentEmail', '==', vm.currentUser.email)
                    .where('status', '==', 'pending')
                    .orderBy('createdAt', 'desc')
                    .limit(1)
                    .get()

                if (studentInvitationsRef.docs.length === 1) {
                    const payload = {invitationID: studentInvitationsRef.docs[0].id}

                    await vm.acceptInvitation(payload).then(result => {
                        console.log('accept result', result)
                    }).catch(err => {
                        console.log('accept error result', err.message)
                    }).finally(() => {
                        vm.loadingFinish = false
                    })
                }
            }

            vm.$nextTick(async () => {
                await vm.$router.push({name: `${vm.accountType}.home`, replace: true})
                vm.loadingFinish = false
            })

            setTimeout(() => {
                if(vm.$route.name === 'basic-info') {
                    vm.$router.push({name: `${vm.accountType}.home`, replace: true})
                    vm.showRetryBtn = true
                }
            }, 5000)
        },
        onRetry() {
            const vm = this
            vm.loadingFinish = true
            vm.$nextTick(async () => {
                await vm.$router.push({name: `${vm.accountType}.home`, replace: true})
                vm.loadingFinish = false
                vm.showRetryBtn = false
            })
        }
    },
}
</script>

<style scoped>

.img-col {
    position: sticky;
    top: 48px;
    background-size: cover;
    background-position: center;
    height: calc(100vh - 20px);
    background-image: url('../../assets/img/welcome.png');
}

</style>
